import { AppState } from '../../app/state/AppState';
import { FeatureFlags } from '../../ts/FeatureFlags';

export function selectCatalogingOnSiteEnabled(state: AppState) {
  return FeatureFlags.metadataAreaEnabled && state.session.info.site.catalogingOnSiteEnabled !== false;
}
